module.exports = __webpack_public_path__ + "static/img/bk5.024f64a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/bk5.jpg
// module id = xyNp
// module chunks = 0